import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M5.794 2.09605C5.795 2.09705 5.797 2.09805 5.798 2.09905L18.794 11.595C18.794 11.595 18.794 11.595 18.794 11.596C18.835 11.626 18.873 11.663 18.905 11.707C19.067 11.93 19.018 12.243 18.794 12.405V12.406L5.794 21.906C5.571 22.068 5.258 22.019 5.096 21.795C5.031 21.705 5 21.602 5 21.5V2.50005C5 2.39805 5.031 2.29505 5.095 2.20605C5.258 1.98305 5.57 1.93305 5.794 2.09605V2.09605Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'RoundedTriangleRightFill');

export default Icon;
